module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_5-253663672d6719ab136f2e785056bc7a.jpg";